export default {"src":"/_next/static/media/arcade.ddd0f2bd.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};